// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WhatsappMessageTemplates_CarregaWhatsappMessageTemplatesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/whatsapp_message_templates/carrega_whatsapp_message_templates
 *
 * Returns the full list of WhatsApp message templates (admin listing),
 * each enriched with comma-joined franchise names (`franquias_nomes`).
 */
import type { WhatsappMessageTemplates_TemplateRow } from './WhatsappMessageTemplates_TemplateRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type WhatsappMessageTemplates_CarregaWhatsappMessageTemplatesResponseDados = WhatsappMessageTemplates_TemplateRow[];

export type WhatsappMessageTemplates_CarregaWhatsappMessageTemplatesResponse = ApiResponse<WhatsappMessageTemplates_CarregaWhatsappMessageTemplatesResponseDados>;

registerResponseContract('WhatsappMessageTemplates_CarregaWhatsappMessageTemplatesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      template_id:        { type: 'number',  required: true },
      template_name:      { type: 'string',  required: true },
      template_content:   { type: 'string',  required: true },
      template_type:      { type: 'string',  required: true },
      template_media_url: { type: 'string',  required: false },
      is_active:          { type: 'number',  required: true },
      franquias_nomes:    { type: 'string',  required: false },
      created_at:         { type: 'string',  required: true },
      updated_at:         { type: 'string',  required: true },
    },
  },
})
